ready().then(function() {
    const showaffiliates = () => {
        const showAvailable = $('.btn-affiliates');
        const affiliateLinks = $('.book-affiliate-links');

        if(showAvailable) {
            showAvailable.on('click',function(e) {
                e.preventDefault();
                e.stopPropagation();
                showAvailable.next(affiliateLinks).toggleClass('affiliates-visible');
            })

            $(document).on('click',function() {
                showAvailable.next(affiliateLinks).removeClass('affiliates-visible');
            });
        }
    }
    showaffiliates();
});
